import isEqual from "lodash/isEqual";

import { putRequestCase } from "@/stores/caseStore/backendApi";
import { useCaseStore } from "@/stores/caseStore/0_caseStore";
import { withQuestionnaireSource } from "@/stores/caseStore/questionnaireSource";
import { useSnackbarStore } from "@/stores/snackbarStore";
import * as d from "@/utils/dataUtils";

// model

export const defaultCaseData = {
  id: 0,
  hasWitnesses: null,
  remarks: "",
};

// CRUD

/**
 * Fehler werden per Snackbar gemeldet und – wie bisher – NICHT weitergereicht.
 * Mit `{ rethrow: true }` zusätzlich weiterreichen (Fragebogen-Hülle: zeigt
 * dann „Nicht gespeichert“ statt „Gespeichert“).
 */
export async function saveRemarks(options: { rethrow?: boolean } = {}): Promise<void> {
  const store = useCaseStore();
  const snackbar = useSnackbarStore();

  try {
    const currentRemarks = store.caseData.remarks;
    const previousRemarks = store.lastSavedCaseData.remarks;

    if (isEqual(currentRemarks, previousRemarks)) return;

    await putRequestCase(withQuestionnaireSource(`/protected/cases/${store.caseData.id}/questionnaire`, store.questionnaireView), { remarks: currentRemarks });

    store.lastSavedCaseData.remarks = store.caseData.remarks;
  } catch (error: unknown) {
    const msg = error instanceof Error ? error.message : (error as any)?.message || "Fehler beim Speichern";
    snackbar.showSnackbar({ message: msg, type: "error" });
    if (options.rethrow) throw error;
  }
}

// data helper

type CaseData = Record<string, any>;

export function prepareCaseDataForLoad(data: CaseData): CaseData {
  return {
    ...data,
    hasWitnesses: d.loadTristate(data.hasWitnesses),
  };
}

export function prepareCaseDataForSave(data: CaseData): CaseData {
  return {
    ...data,
    hasWitnesses: d.saveTristate(data.hasWitnesses),
  };
}
